module.exports = __webpack_public_path__ + "img/barcode.c71efa81.png";